{
  "fr": {
    "document": {
      "actions": {
        "clear_selection": "Effacer la sélection",
        "delete": "Supprimer",
        "deleteMultipleDocuments": "Supprimer",
        "delete_cancel": "Annuler",
        "delete_documents": "Supprimer document | Supprimer documents",
        "delete_documents_upload": "Supprimer le document {count} | Supprimer les documents {count} ",
        "download": "Télécharger",
        "edit": "Modifier",
        "edit_category": "Modifier la catégorie",
        "groupByCategory": "Regroupement par catégorie",
        "hideDetails": "Cacher détails",
        "hide_for_project_partners": "Masquer pour les partenaires du projet",
        "new": "Documents",
        "new_customer": "Ajouter des documents",
        "reset_filters": "Réinitialiser les filtres",
        "select_all": "Sélectionner les {total} documents",
        "share": "Partager",
        "shareCustomer": "Partager avec le client",
        "shareCustomerPartners": "Partager avec le client et les partenaires du projet",
        "share_documents": "Partager le document | Partager des documents",
        "share_with": "Partager avec...",
        "share_with_project_partners": "Partager avec les partenaires du projet",
        "showDetails": "Montrer détails",
        "submit": "Enregistrer",
        "tickBoxesDeletion": "Sélectionner les documents que vous souhaitez supprimer.",
        "unshare": "Annuler le partage",
        "unshare_documents": "Annuler le partage du document | Annuler le partage de documents"
      },
      "attachable_types": {
        "building": "Bâtiment",
        "decisions": "Décisions",
        "installment": "Versement",
        "issue": "Le point",
        "lot": "Lot",
        "phase": "Phase",
        "project": "Projet",
        "tickets": "Conversations",
        "unit": "Unité"
      },
      "attributes": {
        "category": "Catégorie",
        "file_ext": "Type de Document",
        "file_size": "Taille du Document",
        "name": "Nom",
        "size": "Taille",
        "type": "Type",
        "uploaded_at": "Téléchargé à",
        "uploaded_by": "Téléchargé par"
      },
      "category": {
        "admin": "Administration",
        "aftercare": "Après-vente",
        "as_built": "Dossier d'intervention ultérieure",
        "brochure": "Brochure",
        "conversation": "Conversation",
        "decision": "Décision",
        "image": "Image",
        "invoice": "Facture",
        "legal": "Juridique",
        "manual": "Manuel",
        "other": "Autre",
        "plan": "Plan",
        "quote": "Offre",
        "ticket": "Conversation"
      },
      "labels": {
        "actions": "Actions",
        "allDocuments": "All documents",
        "allUnits": "Toutes les Unités",
        "backToCategories": "Catégories",
        "building": "bâtiment",
        "categories": "Catégories",
        "category": "Catégorie",
        "changeCategory": "Changer de catégorie en :",
        "changeFilterOrStartUploading": "Changer de filtre ou télécharger un nouveau document",
        "created": "Créé",
        "customer": "Client",
        "decision": "décision",
        "decisionsAndProposals": "Décisions et Propositions",
        "delete_documents": "Êtes-vous sûr de vouloir supprimer ce document ? Cette action ne peut être annulée. | Êtes-vous sûr de vouloir supprimer ces documents ? Cette action ne peut être annulée.",
        "disclaimerDocumentsCustomer": "Recherchez ou téléchargez des documents liés à la décision {decision_name}",
        "documents": "Documents",
        "documents_all": "Tous les documents",
        "documents_all_projects": "Documents tous les projets",
        "documents_plan": "Documents de plan",
        "documents_plan_explainer": "Les documents ajoutés au dossier de documents de l'unité {unit_name} avec la catégorie 'Plan' sont automatiquement ajoutés à cette décision et accessibles à tous les partenaires.",
        "editDocument": "Modifier document",
        "editDocumentName": "Modifier le nom du document",
        "editDocumentNameSubtitle": "Saisissez un nouveau nom pour le document.",
        "fileTooLargeForPreview": "Fichier trop volumineux pour être prévisualisé. Essayez de le télécharger.",
        "files": "Documents {level_name}",
        "files_count": "Aucun fichier | 1 fichier | {count} fichiers",
        "filter": "Filtrer",
        "folders": "Dossiers",
        "goToUnitDocumentsFolder": "Accéder au dossier de documents {unit_name}",
        "goToUnitsFolder": "Cette page ne contient que des documents de décision. Allez dans le dossier de l'unité pour voir les autres documents.",
        "include_original_documents": "Afficher les documents à signer",
        "includesProposalAndDocuments": "Comprend les documents de proposition et les documents de décision",
        "info": "Les documents relatifs à votre maison seront bientôt disponibles ici.",
        "lockedDocumentApprovedProposal": "Ce document appartient à une proposition approuvée et ne peut pas être supprimé",
        "lockedDocumentDelete": "Ce document ne peut pas être supprimé",
        "lockedDocumentOtherLevel": "Ce document appartient à {level} et ne peut être supprimé que depuis les documents de {level}",
        "lockedDocumentShareLevel": "Ce document appartient à {level} et ne peut pas être partagé avec les partenaires du projet",
        "locked_parent_level": "Ce document est géré à un niveau supérieur et ne peut être modifié ou supprimé qu'à ce niveau",
        "locked_template": "Ce document a été créé à partir d'un modèle et ne peut pas être modifié ou supprimé",
        "lot": "lot",
        "more_info": "Plus d'info",
        "name_asc": "Nom A->Z",
        "name_desc": "Nom Z->A",
        "name_lower_asc": "Nom A->Z",
        "name_lower_desc": "Nom Z->A",
        "new": "Nouveau",
        "next": "Suivant",
        "noCustomer": "Aucun client assigné pour l'instant",
        "noPreviewPossible": "Aucun aperçu possible. Essayez de le télécharger d'abord.",
        "noResults": "Pas de résultats",
        "no_plan_documents": "Aucun document de plan ajouté au dossier de l'unité",
        "onlyUnitDocumentsSharedWithProjectPartners": "Seuls les documents de l'unité peuvent être partagés avec les partenaires du projet",
        "original_documents": "Documents originaux",
        "original_documents_info": "Afficher les versions originales non signées des documents qui sont signés ou qui doivent être signés.",
        "owner": "Propriétaire",
        "page": "Page",
        "phase": "phase",
        "previous": "Précédent",
        "project": "projet",
        "project_partners": "Partenaires du projet",
        "proposal": "proposition",
        "searchName": "Recherche par nom",
        "search_document": "Rechercher un document",
        "selected": "{count} document sélectionné | {count} documents sélectionnés",
        "selected_count": "{selected} document sélectionné | {selected} documents sélectionnés",
        "shareWith": "Partager avec",
        "sharedWithClient": "Partagé avec {client_name}",
        "sharedWithProjectPartners": "Partagé avec les partenaires du projet",
        "shared_with": "Partager avec",
        "shared_with_partners": "Partagé avec des partenaires",
        "sharingSettingsDecision": "Dans cette décision",
        "sharingSettingsProject": "Dans ce projet",
        "showDocumentsFor": "Montrer les documents de",
        "showLevel": "Ceci est un document {level}",
        "signature": "Signature",
        "signed": "Signé",
        "signedBy": "Signé par",
        "source": "Origin",
        "subtitleSharingDocuments": "Le document sélectionné sera disponible pour les partenaires du projet | Les documents sélectionnés seront disponibles pour les partenaires du projet",
        "subtitleUnsharingDocuments": "Le document sélectionné ne sera pas disponible pour les partenaires du projet | Les documents sélectionnés ne seront pas disponibles pour les partenaires du projet",
        "ticket": "conversation",
        "total_selected": "Les {total} documents sont sélectionnés",
        "unit": "unité",
        "unitFolder": "Aller aux documents de l'unité",
        "updated_at_asc": "Le plus ancien en premier",
        "updated_at_desc": "Le plus récent d'abord",
        "upload_failed": "1 ou plusieurs fichiers n'ont pas pu être téléchargés. Supprimez-les ou réessayez de télécharger à nouveau.",
        "uploadedBy": "Telechargé par",
        "visibleFor": "Partagé avec",
        "warningNotShared": "Oups! Personne n'a été sélectionné. Êtes-vous sûr? Cliquez à nouveau pour confirmer."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Vous recevrez une notification par e-mail lorsqu'un nouveau document sera disponible. Visualisez-les et téléchargez-les ici.",
            "title": "Ici vous trouverez tous vos documents"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Les documents téléchargés informeront automatiquement tous les clients liés par email.",
            "title": "Aucun document pour {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Naviguer dans la structure du projet pour voir les documents d'une unité",
            "title": "Aller à une unité pour voir les documents"
          },
          "new": {
            "subtitle": "Les documents téléchargés informeront automatiquement tous les clients liés par email.",
            "title": "Aucun document pour cette décision"
          },
          "none": {
            "subtitle": "Vous trouverez ici les documents pour {unit}",
            "title": "Pas encore de documents"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Document supprimé avec succès | Documents supprimés avec succès",
        "bulk_upload": "Document téléchargé avec succès | Documents téléchargés avec succès",
        "update": "{count} document mis à jour avec succès | {count} documents mis à jour avec succès",
        "upload_success": "{count} document téléchargé avec succès | {count} documents téléchargés avec succès"
      },
      "upload": {
        "activeUpload": "Téléchargement du fichier {count} | Téléchargement des fichiers {count} ",
        "clear": "Effacer",
        "complete": "Téléchargement complet",
        "navigationWarning": {
          "continue": "Quitter quand même",
          "header": "Téléchargement en cours",
          "message": "Des fichiers sont en cours de téléchargement. Quitter cette page annulera le téléchargement et aucun document ne sera créé."
        },
        "uploadFailed": "Échec du téléchargement"
      },
      "validation": {
        "need_category": "Catégorie requise",
        "need_category_all": "Tous les documents doivent avoir une catégorie",
        "selectDocument": "Sélectionnez au moins 1 document"
      }
    }
  }
}
